import React, { useState } from "react";

import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import calendar1 from "assets/img/calendar1.png";
import tag from "assets/img/tag.webp";
import baby1 from "assets/img/baby1.jpg";
import momchild from "assets/img/momchild.jpg";
import contact from "assets/img/contact.png";
import bgg from "assets/img/bgg.png";
import bfly1 from "assets/img/bfly1.webp";
import clouds from "assets/img/clouds.webp";

export default function Blog() {
  return (
    <>
      <AdminNavbar fixed />

      <section
        className=" parkinsans xl:block lg:block md:hidden sm:hidden hidden xl:h-400"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "35% auto",
        }}
      >
        <div className=" container mx-auto gap-6 xl:px-0 px-4">
          <div className=" flex justify-start top-0 absolute right-0 ">
            <img
              className="xl:w-32 lg:w-32 md:w-32 w-20 xl:pt-0 lg:pt-0 md:pt-8"
              src={clouds}
              alt=""
            />
          </div>
        </div>
        <div>
          <h1 className="xl:text-6xl lg:text-5xl md:text-4xl text-2xl text-black text-center font-bold xl:pt-48 lg:pt-40">
            Blog Detail
          </h1>
        </div>
        <div>
          <div className=" ">
            <img className="xl:w-44 w-32 " src={bfly1} alt="" />
          </div>
        </div>
      </section>

      {/* tab and mobile */}
      <section
        className=" parkinsans xl:hidden lg:hidden md:block sm:block block md:h-320"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "35% auto",
        }}
      >
        <div className=" container mx-auto gap-6 xl:px-0 px-4">
          <div className=" flex justify-start top-0 absolute right-0 pt-16">
            <img className=" md:w-24 w-12 md:pt-8" src={clouds} alt="" />
          </div>
        </div>
        <div>
          <h1 className="md:text-4xl text-3xl text-black text-center font-bold md:pt-44 pt-32">
            Blog Detail
          </h1>
        </div>
        <div>
          <div className=" ">
            <img className=" md:w-32 w-20 " src={bfly1} alt="" />
          </div>
        </div>
      </section>

      <section className="container mx-auto xl:mt-16 xl:pb-16 lg:mt-16 lg:pb-16 mt-12 pb-16 xl:px-0 px-4 xl:block lg:blocl md:block sm:hidden hidden">
        <div className="grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1  xl:ml-12">
          <div className="md:col-span-6 lg:col-span-6  md:col-span-5  ">
            <div>
              <div
                className="xl:h-400 lg:h-400 md:h-320 h-350-px"
                style={{
                  backgroundImage: `url(${baby1})`,
                  width: "84%",

                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="flex justify-between xl:w-10/12 w-10/12  xl:mt-6 mt-6">
              <div className="flex gap-2">
                <div>
                  <img class="w-4" src={contact} alt="" />
                </div>
                <p className="text-black text-sm">
                  <span className="text-black font-semibold ">
                    Written By :
                  </span>
                  Junior Toes
                </p>
              </div>

              <div className="flex gap-2">
                <div>
                  <img class="w-4" src={calendar1} alt="" />
                </div>
                <p className="text-orange text-sm">May 16, 2024</p>
              </div>

              <div className="flex gap-2">
                <div>
                  <img class="w-4" src={tag} alt="" />
                </div>
                <p className="text-black text-sm">
                  <span className="text-black font-semibold ">Tags:</span> Exam,
                  Teachers
                </p>
              </div>
            </div>
            <div className="xl:w-10/12 w-10/12 mt-4 xl:mt-4">
              <hr className="border-blue-50"></hr>
            </div>
            <div className="xl:w-10/12 w-10/12">
              <h1 className="text-black text-4xl font-bold xl:mt-4 mt-4">
                Achieve goals with precision & speed
              </h1>
              <p className="text-gray xl:pt-4 text-lg pt-4">
                Consectetur adipisicing elit, sed do eiusmod tempor incididunt
                ut labore et dolore of magna aliqua. Ut enim ad minim veniam,
                made of owl the quis nostrud exercitation ullamco laboris nisi
                ut aliquip ex ea dolor commodo consequat. Duis aute irure and
                dolor in reprehenderit.
              </p>

              <p className="text-gray xl:pt-4 text-lg pt-4">
                The is ipsum dolor sit amet consectetur adipiscing elit. Fusce
                eleifend porta arcu In hac habitasse the is platea augue
                thelorem turpoi dictumst. In lacus libero faucibus at malesuada
                sagittis placerat eros sed istincidunt augue ac ante rutrum sed
                the is sodales augue consequat.
              </p>

              <p className="text-gray xl:pt-4 text-lg pt-4">
                Nulla facilisi. Vestibulum tristique sem in eros eleifend
                imperdiet. Donec quis convallis neque. In id lacus pulvinar
                lacus, eget vulputate lectus. Ut viverra bibendum lorem, at
                tempus nibh mattis in. Sed a massa eget lacus consequat auctor.
              </p>

              <div className="bg-6 borderleft xl:p-8 xl:mt-4 p-6 mt-4">
                <p className="text-gray xl:pt-4 text-lg pt-4">
                  Pellentesque sollicitudin congue dolor non aliquam. Morbi
                  volutpat, nisi vel ultricies urnacondimentum, sapien neque
                  lobortis tortor, quis efficitur mi ipsum eu metus. Praesent
                  eleifend orci sit amet est vehicula.
                </p>
              </div>
              <p className="text-gray xl:pt-4 text-lg pt-4">
                Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et
                massa mi. Aliquam in hendrerit urna. Pellentesque sit amet
                sapien fringilla, mattis ligula consectetur, ultrices mauris.
                Maecenas vitae mattis tellus. Nullam quis imperdiet augue.
                Vestibulum auctor ornare leo, non suscipit magna interdum eu.
                Curabitur pellentesque nibh nibh, at maximus ante fermentum sit
                amet. Pellentesque commodo lacus at sodales sodales. Quisque
                sagittis orci ut diam condimentum, vel euismod erat placerat. In
                iaculis arcu eros.
              </p>

              <div className="grid grid-cols-2 xl:mt-8 gap-4 mt-6">
                <div>
                  <div>
                    <img
                      className="xl:w-12/12 w-12/12 rounded"
                      src={momchild}
                      alt=""
                    />
                  </div>
                </div>

                <div>
                  <div>
                    <img
                      className="xl:w-12/12 w-12/12 rounded"
                      src={momchild}
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <p className="text-gray xl:pt-8 pt-4 text-lg">
                Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et
                massa mi. Aliquam in hendrerit urna. Pellentesque sit amet
                sapien fringilla, mattis ligula consectetur, ultrices mauris.
                Maecenas vitae mattis tellus. Nullam quis imperdiet augue.
                Vestibulum auctor ornare leo, non suscipit magna interdum eu.
                Curabitur pellentesque nibh nibh, at maximus ante fermentum sit
                amet. Pellentesque commodo lacus at sodales sodales. Quisque
                sagittis orci ut diam condimentum, vel euismod erat placerat. In
                iaculis arcu eros.
              </p>

              <div className=" xl:mt-6 mt-6">
                <hr className="border-blue-50"></hr>
              </div>

              <div className="xl:block lg:block md:block sm:hidden hidden">
                <div className="flex justify-between xl:mt-6 mt-4">
                  <div className="flex items-center">
                    <h1 className="text-black text-base font-semibold">
                      Tags:
                    </h1>
                    <button className="bg-6 px-4 py-1 ml-4">Canteen</button>
                    <button className="bg-6 px-4 py-1 ml-2">Teachers</button>
                  </div>

                  <div className="flex items-center">
                    <h1 className="text-black text-base font-semibold">
                      Share:
                    </h1>
                    <button className="text-black text-xl ml-4">
                      <i className="fab fa-facebook"></i>
                    </button>
                    <button className="text-black text-xl ml-2">
                      <i className="fab fa-twitter"></i>
                    </button>
                    <button className="text-black text-xl ml-2">
                      <i className="fab fa-linkedin"></i>
                    </button>
                    <button className="text-black text-xl ml-2">
                      <i className="fab fa-instagram"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className=" xl:mt-6 mt-6">
                <hr className="border-blue-50"></hr>
              </div>

              <div className="bordergrey flex justify-between items-center xl:p-6 xl:mt-6 p-4 mt-4">
                <div className="h-10 w-10 rounded-full bg-2">
                  <a href="/GridPage">
                    <p className="text-base text-black text-center font-bold pt-2">
                      ←
                    </p>
                  </a>
                </div>
                <div>
                  <p className="text-orange text-4xl">❖</p>
                </div>
              </div>

              <div>
                <h1 className="text-4xl text-black xl:mt-6 mt-4">
                  Leave A Comment{" "}
                </h1>
                <form className="xl:mt-6 mt-6">
                  <input
                    className="xl:w-12/12 w-12/12 borderform "
                    type="text"
                    id="text"
                    placeholder="Name"
                    required
                  />

                  <input
                    className="xl:w-12/12 w-12/12 borderform mt-4"
                    type="text"
                    id="text"
                    placeholder="Email"
                    required
                  />

                  <input
                    className="xl:w-12/12 w-12/12 borderform mt-4"
                    type="text"
                    id="text"
                    placeholder="Subject"
                    required
                  />

                  <textarea
                    className="xl:w-12/12 w-12/12 borderform mt-4 "
                    id="comments"
                    name="comments"
                    rows="5"
                    placeholder="Comment"
                    required
                  ></textarea>
                  <div className="flex">
                    <input className="mt-1" type="checkbox" />
                    <p className="text-lg text-gray ml-2">
                      Save my name, email, and website in this browser for the
                      next time I comment.
                    </p>
                  </div>
                  <button
                    className="bg-orange text-white xl:mt-6 px-8 py-2 mt-4"
                    type="submit"
                  >
                    Post Comment
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/*2nd grid*/}
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2 xl:-ml-24 lg:-ml-16 md:-ml-12">
            <div className="bg-6 xl:p-8 p-4 ">
              <h2 class="text-xl text-black font-bold">Search</h2>
              <div class="orangeborder mb-4"></div>
              <div class="flex items-center justify-between bg-white rounded-md shadow-md">
                <p className="xl:w-10/12 ml-2 text-sm text-gray py-4">
                  Search Here
                </p>
                <button class="bg-orange  text-white px-6 py-4 rounded-md">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>

            <div className="bg-6 xl:p-8 xl:mt-6 p-4 mt-6">
              <h2 class="text-xl text-black font-bold">Category</h2>
              <div class="orangeborder mb-4"></div>
              <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 hover-box">
                <p className="xl:w-10/12  text-lg text-gray py-4 hover-box">
                  Teachers
                </p>
                <p>(1)</p>
              </div>

              <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
                <p className="xl:w-10/12  text-sm text-gray py-4 hover-box">
                  Students
                </p>
                <p>(1)</p>
              </div>

              <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
                <p className="xl:w-10/12  text-sm text-gray py-4 hover-box">
                  Classes
                </p>
                <p>(1)</p>
              </div>

              <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
                <p className="xl:w-10/12  text-sm text-gray py-4 hover-box">
                  Exams
                </p>
                <p>(1)</p>
              </div>

              <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
                <p className="xl:w-10/12  text-sm text-gray py-4 hover-box">
                  School
                </p>
                <p>(1)</p>
              </div>

              <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
                <p className="xl:w-10/12  text-sm text-gray py-4 hover-box">
                  Education
                </p>
                <p>(1)</p>
              </div>
            </div>

            <div className="bg-6 xl:p-8 p-6 mt-6 xl:mt-6 xl:block lg:block md:hidden sm:hidden hidden">
              <h2 class="text-xl text-black font-bold">Recent Post</h2>
              <div class="orangeborder mb-4"></div>
              <div className="flex items-start gap-2">
                {/* Blog Image */}
                <div className="xl:w-5/12 ">
                  <img className="xl:w-12/12" src={momchild} alt="Blog Image" />
                </div>

                {/* Date and May 16 text */}
                <div className="flex flex-col justify-start xl:ml-2 xl:mt-4">
                  <div className="flex gap-2">
                    <img className="w-4" src={calendar1} alt="Date Icon" />
                    <p className="text-orange text-sm">May 16, 2024</p>
                  </div>

                  {/* text-graygraph Content */}
                  <p className="text-sm  text-black">
                    Questions to Ask Vendors Before LMS Platform
                  </p>
                </div>
              </div>

              <div className="flex items-start mt-4 gap-2">
                {/* Blog Image */}
                <div className="xl:w-5/12">
                  <img className="xl:w-12/12" src={momchild} alt="Blog Image" />
                </div>

                {/* Date and May 16 text */}
                <div className="flex flex-col justify-start xl:ml-2 xl:mt-4 ">
                  <div className="flex gap-2 ">
                    <img className="w-4" src={calendar1} alt="Date Icon" />
                    <p className="text-orange text-sm">May 16, 2024</p>
                  </div>

                  {/* text-graygraph Content */}
                  <p className="text-sm text-black ">
                    Questions to Ask Vendors Before LMS Platform
                  </p>
                </div>
              </div>

              <div className="flex items-start mt-4 gap-2">
                {/* Blog Image */}
                <div className="xl:w-5/12">
                  <img className="xl:w-12/12" src={momchild} alt="Blog Image" />
                </div>

                {/* Date and May 16 text */}
                <div className="flex flex-col justify-start xl:ml-2 xl:mt-4">
                  <div className="flex gap-2">
                    <img className="w-4" src={calendar1} alt="Date Icon" />
                    <p className="text-orange text-sm">May 16, 2024</p>
                  </div>

                  {/* text-graygraph Content */}
                  <p className="text-sm text-black ">
                    Questions to Ask Vendors Before LMS Platform
                  </p>
                </div>
              </div>
            </div>

            {/* tab view */}
            <div className="bg-6 xl:p-8 p-6 mt-6 xl:mt-6 xl:hidden lg:hidden md:block sm:hidden hidden">
              <h2 class="text-xl text-black font-bold">Recent Post</h2>

              <div className="mt-4">
                <div className="">
                  <img className="w-32 " src={momchild} alt="Blog Image" />
                </div>

                <div className="flex flex-col justify-start xl:ml-2 mt-4">
                  <div className="flex gap-2">
                    <img className="w-4" src={calendar1} alt="Date Icon" />
                    <p className="text-orange text-sm">May 16, 2024</p>
                  </div>

                  <p className="text-sm  text-black mt-2">
                    Questions to Ask Vendors Before LMS Platform
                  </p>
                </div>
              </div>

              <div className="mt-6">
                <div className="">
                  <img className="w-32 " src={momchild} alt="Blog Image" />
                </div>

                <div className="flex flex-col justify-start xl:ml-2 mt-4">
                  <div className="flex gap-2">
                    <img className="w-4" src={calendar1} alt="Date Icon" />
                    <p className="text-orange text-sm">May 16, 2024</p>
                  </div>

                  <p className="text-sm  text-black mt-2">
                    Questions to Ask Vendors Before LMS Platform
                  </p>
                </div>
              </div>

              <div className="mt-6">
                <div className="">
                  <img className="w-32 " src={momchild} alt="Blog Image" />
                </div>

                <div className="flex flex-col justify-start xl:ml-2 mt-4">
                  <div className="flex gap-2">
                    <img className="w-4" src={calendar1} alt="Date Icon" />
                    <p className="text-orange text-sm">May 16, 2024</p>
                  </div>

                  <p className="text-sm  text-black mt-2">
                    Questions to Ask Vendors Before LMS Platform
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-6 xl:p-8 xl:mt-6 p-6 mt-6 xl:block lg:block md:hidden sm:hidden hidden">
              <h2 class="text-xl text-black font-bold">Tags:</h2>
              <div class="orangeborder mb-4"></div>
              <div className="flex items-center">
                <button className="bg-white px-4 py-1 text-sm">Students</button>
                <button className="bg-white px-4 py-1 ml-2 text-sm">
                  Teachers
                </button>
                <button className="bg-white px-4 py-1 ml-2 text-sm">
                  Canteen
                </button>
              </div>
              <div className="flex items-center mt-4">
                <button className="bg-white px-4 py-1 text-sm">On-time</button>
                <button className="bg-white px-4 py-1 ml-2 text-sm">
                  Sports
                </button>
              </div>
            </div>

            {/* tab view */}
            <div className="bg-6 p-6 mt-6 xl:hidden lg:hidden md:block sm:hidden hidden">
              <h2 class="text-xl text-black font-bold">Tags:</h2>

              <div className=" ">
                <div className="flex justify-center">
                  <button className="bg-white w-12/12 py-1 text-sm mt-4">
                    Students
                  </button>
                </div>
                <div className="flex justify-center">
                  <button className="bg-white w-12/12 py-1 text-sm mt-4">
                    Teachers
                  </button>
                </div>
                <div className="flex justify-center">
                  <button className="bg-white w-12/12 py-1 text-sm mt-4">
                    Canteen
                  </button>
                </div>
              </div>
              <div className="">
                <div className="flex justify-center">
                  <button className="bg-white w-12/12 py-1 text-sm mt-4">
                    On-Time
                  </button>
                </div>
                <div className="flex justify-center">
                  <button className="bg-white w-12/12 py-1 text-sm mt-4">
                    Sports
                  </button>
                </div>
              </div>
            </div>
            {/* tab view ends */}
          </div>
        </div>
      </section>

      {/* mobileview */}
      <section className="xl:hidden lg:hidden md:hidden sm:block block px-4">
        <div className=" mt-8 ">
          <div>
            <div>
              <img className="w-12/12" src={baby1} alt="" />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div className="flex gap-2">
              <div>
                <img class="w-4" src={contact} alt="" />
              </div>
              <p className="text-black text-sm">
                <span className="text-black font-semibold ">Written By :</span>
                Junior Toes
              </p>
            </div>

            <div className="flex gap-2">
              <div>
                <img class="w-4" src={calendar1} alt="" />
              </div>
              <p className="text-orange text-sm">May 16, 2024</p>
            </div>

            {/* <div className="flex gap-2">
                <div>
                  <img class="w-4" src={tag} alt="" />
                </div>
                <p className="text-black text-sm">
                  <span className="text-black font-semibold ">Tags:</span> Exam,
                  Teachers
                </p>
              </div> */}
          </div>
          <div className=" w-12/12 mt-4 ">
            <hr className="border-blue-50"></hr>
          </div>
          <div className=" ">
            <h1 className="text-black text-2xl font-bold mt-4">
              Achieve goals with precision & speed
            </h1>
            <p className="text-gray text-lg pt-4">
              Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
              labore et dolore of magna aliqua. Ut enim ad minim veniam, made of
              owl the quis nostrud exercitation ullamco laboris nisi ut aliquip
              ex ea dolor commodo consequat. Duis aute irure and dolor in
              reprehenderit.
            </p>

            <p className="text-gray  text-lg pt-4">
              The is ipsum dolor sit amet consectetur adipiscing elit. Fusce
              eleifend porta arcu In hac habitasse the is platea augue thelorem
              turpoi dictumst. In lacus libero faucibus at malesuada sagittis
              placerat eros sed istincidunt augue ac ante rutrum sed the is
              sodales augue consequat.
            </p>

            <p className="text-gray text-lg pt-4">
              Nulla facilisi. Vestibulum tristique sem in eros eleifend
              imperdiet. Donec quis convallis neque. In id lacus pulvinar lacus,
              eget vulputate lectus. Ut viverra bibendum lorem, at tempus nibh
              mattis in. Sed a massa eget lacus consequat auctor.
            </p>

            <div className="bg-6 borderleft  p-6 mt-4">
              <p className="text-gray  text-lg pt-4">
                Pellentesque sollicitudin congue dolor non aliquam. Morbi
                volutpat, nisi vel ultricies urnacondimentum, sapien neque
                lobortis tortor, quis efficitur mi ipsum eu metus. Praesent
                eleifend orci sit amet est vehicula.
              </p>
            </div>
            <p className="text-gray  text-lg pt-4">
              Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa
              mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien
              fringilla, mattis ligula consectetur, ultrices mauris. Maecenas
              vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum
              auctor ornare leo, non suscipit magna interdum eu. Curabitur
              pellentesque nibh nibh, at maximus ante fermentum sit amet.
              Pellentesque commodo lacus at sodales sodales. Quisque sagittis
              orci ut diam condimentum, vel euismod erat placerat. In iaculis
              arcu eros.
            </p>

            <div className="  mt-6">
              <div>
                <div>
                  <img className=" w-12/12 rounded" src={momchild} alt="" />
                </div>
              </div>
            </div>

            <p className="text-gray  pt-4 text-lg">
              Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa
              mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien
              fringilla, mattis ligula consectetur, ultrices mauris. Maecenas
              vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum
              auctor ornare leo, non suscipit magna interdum eu. Curabitur
              pellentesque nibh nibh, at maximus ante fermentum sit amet.
              Pellentesque commodo lacus at sodales sodales. Quisque sagittis
              orci ut diam condimentum, vel euismod erat placerat. In iaculis
              arcu eros.
            </p>

            <div className="  mt-6">
              <hr className="border-blue-50"></hr>
            </div>

            <div className="">
              <div className="flex justify-between xl:mt-6 mt-4">
                <div className="flex justify-between">
                  <h1 className="text-black text-base font-semibold">Tags:</h1>
                  <button className="bg-6 px-4 py-1 ml-4">Canteen</button>
                  <button className="bg-6 px-4 py-1 ml-2">Teachers</button>
                </div>
              </div>

              <div className="flex mt-4">
                <h1 className="text-black text-base font-semibold">Share:</h1>
                <button className="text-black text-xl ml-4">
                  <i className="fab fa-facebook"></i>
                </button>
                <button className="text-black text-xl ml-2">
                  <i className="fab fa-twitter"></i>
                </button>
                <button className="text-black text-xl ml-2">
                  <i className="fab fa-linkedin"></i>
                </button>
                <button className="text-black text-xl ml-2">
                  <i className="fab fa-instagram"></i>
                </button>
              </div>
            </div>

            <div className=" xl:mt-6 mt-6">
              <hr className="border-blue-50"></hr>
            </div>

            <div className="bordergrey flex justify-between items-center xl:p-6 xl:mt-6 p-4 mt-4">
              <div className="h-10 w-10 rounded-full bg-2">
                <a href="/GridPage">
                  <p className="text-base text-black text-center font-bold pt-2">
                    ←
                  </p>
                </a>
              </div>
              <div>
                <p className="text-orange text-4xl">❖</p>
              </div>
            </div>

            <div>
              <h1 className="text-4xl text-black xl:mt-6 mt-4">
                Leave A Comment{" "}
              </h1>
              <form className="xl:mt-6 mt-6">
                <input
                  className="xl:w-12/12 w-12/12 borderform "
                  type="text"
                  id="text"
                  placeholder="Name"
                  required
                />

                <input
                  className="xl:w-12/12 w-12/12 borderform mt-4"
                  type="text"
                  id="text"
                  placeholder="Email"
                  required
                />

                <input
                  className="xl:w-12/12 w-12/12 borderform mt-4"
                  type="text"
                  id="text"
                  placeholder="Subject"
                  required
                />

                <textarea
                  className="xl:w-12/12 w-12/12 borderform mt-4 "
                  id="comments"
                  name="comments"
                  rows="5"
                  placeholder="Comment"
                  required
                ></textarea>
                <div className="flex">
                  <input className="mt-1" type="checkbox" />
                  <p className="text-lg text-gray ml-2">
                    Save my name, email, and website in this browser for the
                    next time I comment.
                  </p>
                </div>
                <button
                  className="bg-orange text-white xl:mt-6 px-8 py-2 mt-4"
                  type="submit"
                >
                  Post Comment
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* mobile view 2nd grid */}
        <div className="pb-12">
          <div className="bg-6  p-4 mt-6">
            <h2 class="text-xl text-black font-bold">Search</h2>
            <div class="orangeborder mb-4"></div>
            <div class="flex items-center justify-between bg-white rounded-md shadow-md">
              <p className="xl:w-10/12 ml-2 text-sm text-gray py-4">
                Search Here
              </p>
              <button class="bg-orange  text-white px-6 py-4 rounded-md">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>

          <div className="bg-6   p-4 mt-6">
            <h2 class="text-xl text-black font-bold">Category</h2>
            <div class="orangeborder mb-4"></div>
            <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 hover-box">
              <p className=" text-lg text-gray py-4 hover-box">Teachers</p>
              <p>(1)</p>
            </div>

            <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
              <p className=" text-sm text-gray py-4 hover-box">Students</p>
              <p>(1)</p>
            </div>

            <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
              <p className="xl:w-10/12  text-sm text-gray py-4 hover-box">
                Classes
              </p>
              <p>(1)</p>
            </div>

            <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
              <p className="  text-sm text-gray py-4 hover-box">Exams</p>
              <p>(1)</p>
            </div>

            <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
              <p className="  text-sm text-gray py-4 hover-box">School</p>
              <p>(1)</p>
            </div>

            <div class="flex items-center justify-between bg-white rounded-md shadow-md px-4 mt-2 hover-box">
              <p className="  text-sm text-gray py-4 hover-box">Education</p>
              <p>(1)</p>
            </div>
          </div>

          <div className="bg-6 xl:p-8 p-6 mt-6 xl:mt-6 ">
            <h2 class="text-xl text-black font-bold">Recent Post</h2>
            <div class="orangeborder mb-4"></div>
            <div className="flex items-start gap-4">
              {/* Blog Image */}
              <div className=" w-36">
                <img className="" src={momchild} alt="Blog Image" />
              </div>

              {/* Date and May 16 text */}
              <div className="flex flex-col justify-start mt-2">
                <div className="flex gap-2">
                  <img className="w-4" src={calendar1} alt="Date Icon" />
                  <p className="text-orange text-sm">May 16, 2024</p>
                </div>

                {/* text-graygraph Content */}
                <p className="text-sm  text-black">
                  Questions to Ask Vendors Before LMS Platform
                </p>
              </div>
            </div>

            <div className="flex items-start mt-4 gap-4">
              {/* Blog Image */}
              <div className="w-36">
                <img className="" src={momchild} alt="Blog Image" />
              </div>

              {/* Date and May 16 text */}
              <div className="flex flex-col justify-start mt-4 ">
                <div className="flex gap-2 ">
                  <img className="w-4" src={calendar1} alt="Date Icon" />
                  <p className="text-orange text-sm">May 16, 2024</p>
                </div>

                {/* text-graygraph Content */}
                <p className="text-sm text-black ">
                  Questions to Ask Vendors Before LMS Platform
                </p>
              </div>
            </div>

            <div className="flex items-start mt-4 gap-4">
              {/* Blog Image */}
              <div className="w-36">
                <img className="" src={momchild} alt="Blog Image" />
              </div>

              {/* Date and May 16 text */}
              <div className="flex flex-col justify-start mt-4">
                <div className="flex gap-2">
                  <img className="w-4" src={calendar1} alt="Date Icon" />
                  <p className="text-orange text-sm">May 16, 2024</p>
                </div>

                {/* text-graygraph Content */}
                <p className="text-sm text-black ">
                  Questions to Ask Vendors Before LMS Platform
                </p>
              </div>
            </div>
          </div>

          <div className="bg-6 xl:p-8 xl:mt-6 p-6 mt-6">
            <h2 class="text-xl text-black font-bold">Tags:</h2>
            <div class="orangeborder mb-4"></div>
            <div className="flex items-center">
              <button className="bg-white px-4 py-1 text-sm">Students</button>
              <button className="bg-white px-4 py-1 ml-2 text-sm">
                Teachers
              </button>
              <button className="bg-white px-4 py-1 ml-2 text-sm">
                Canteen
              </button>
            </div>
            <div className="flex items-center mt-4">
              <button className="bg-white px-4 py-1 text-sm">On-time</button>
              <button className="bg-white px-4 py-1 ml-2 text-sm">
                Sports
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </>
  );
}
